module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/6@2x_e8fe17529621af2f438fc381d02cfc01.png";